import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "./Login.css";
import BotTabs from "./BotTabs"
import AinxtTech_Logo from "../Components/images/AinxtTech_logo.png";

export default function Login() {
  const navigate = useNavigate();
  const [Username, setUsername] = useState("");

  const [Ip_Address, setIP_Address] = useState(null);

  const [Password, setPassword] = useState("");
  const [error, setError] = useState("");


  const [touched, setTouched] = useState({ Username: false, Password: false });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const validate = (name, value) => {
    const v = value.trim();
    if (name === "Username") {
      if (!v) return "Username is required.";
      if (/\s/.test(v)) return "Username cannot contain spaces.";
      if (v.includes("@") && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v))
        return "Enter a valid email address.";
      if (v.length < 3) return "Username must be at least 3 characters.";
    }
    if (name === "Password") {
      if (!v) return "Password is required.";
    }
    return "";
  };

  const usernameError = validate("Username", Username);
  const passwordError = validate("Password", Password);

  const onSubmit = (e) => {
    e.preventDefault();
    setTouched({ Username: true, Password: true });
    setError("");
    if (usernameError || passwordError) return;

    const username = Username.trim();
    const password = Password.trim();
    setLoading(true);

    fetch(
      `https://9k80nl2kc2.execute-api.ap-south-1.amazonaws.com/default/Login_API?Username=${encodeURIComponent(
        username
      )}&Password=${encodeURIComponent(password)}&Ip_Address=${Ip_Address}`,

      {
        method: "GET",
        headers: {
          "x-api-key": "eXAnoAXxw5aQCCx5xxsYtISw6FJdNX88Wq36pdWj",
          authorizationToken: "Hghb6GI52e32tWsC",
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 1) {
          if (username === "aisha@finnup.in") {
            sessionStorage.setItem("username", username);
          }
          sessionStorage.setItem("Loggedin", JSON.stringify(data));

          navigate("/BotTabs");
        } else {
          setError("Invalid username or password.");
        }
      })
      .catch(() => setError("Something went wrong. Please try again."))
      .finally(() => setLoading(false));
  };

  if (Ip_Address == null) {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((res) => setIP_Address(res.ip))

      .catch((error) => {
        console.log(`Problem fetching my IP ${error}`);
      });
  }

  return (
    <form className="loginWindow" onSubmit={onSubmit} noValidate>
      <div className="userIconLoginPage">
        <img alt="Logo" src={AinxtTech_Logo} width="150" height="auto" />
      </div>
      <div className="loginHeadingText text-center">Sign In</div>

      {error && (
        <div className="loginAlert" role="alert">
          {error}
        </div>
      )}

      <div className="loginField">
        <input
          type="text"
          autoComplete="username"
          className={`loginTextFeild userIconFeild${
            touched.Username && usernameError ? " inputInvalid" : ""
          }`}
          placeholder="Username"
          value={Username}
          aria-invalid={!!(touched.Username && usernameError)}
          onChange={(e) => setUsername(e.target.value)}
          onBlur={() => setTouched((t) => ({ ...t, Username: true }))}
        />
        {touched.Username && usernameError && (
          <div className="fieldError">{usernameError}</div>
        )}
      </div>

      <div className="loginField">
        <input
          type={showPassword ? "text" : "password"}
          autoComplete="current-password"
          value={Password}
          className={`loginTextFeild passwordIconFeild${
            touched.Password && passwordError ? " inputInvalid" : ""
          }`}
          aria-invalid={!!(touched.Password && passwordError)}
          onChange={(e) => setPassword(e.target.value)}
          onBlur={() => setTouched((t) => ({ ...t, Password: true }))}
          placeholder="Password"
        />
        <button
          type="button"
          className="togglePassword"
          onClick={() => setShowPassword((v) => !v)}
        >
          {showPassword ? "Hide" : "Show"}
        </button>
        {touched.Password && passwordError && (
          <div className="fieldError">{passwordError}</div>
        )}
      </div>

      <div>
        <button
          type="submit"
          className="btn btn-primary mob-w-100 btnFull"
          disabled={loading}
        >
          {loading ? "Signing in..." : "Login"}
        </button>
      </div>

      <div className="row loginOptions">
        <div className="col-6">
          <label className="checkboxDiv">
            <input type="checkbox" />
            <span className="checkmark"></span>Stay logged in
          </label>
        </div>
      </div>
    </form>
  );
}
